import store from '@/store';

export default {
  install(Vue) {
    /**
     * 判读是否是只读权限
     * @param {Array} value 只读权限列表
     * @return {Boolean} 只读 true，否则为 false
     */
    Vue.prototype.checkReadOnlyPermission = function(value) {
      if (value && value instanceof Array && value.length > 0) {
        const readOnly = store.state.readOnly;
        const readOnlyPermission = value;
        const hasReadOnlyPermission = readOnly.some(role => {
          return readOnlyPermission.includes(role);
        });
        return hasReadOnlyPermission;
      } else {
        return false;
      }
    };
  }
};